import ArticlesTiles from './ArticlesTiles';
import ArticlesTilesWithFallback from './ArticlesTilesWithFallback';

export { ArticlesTiles, ArticlesTilesWithFallback };
export default ArticlesTiles;
